<template>
    <div>
        <vs-card>
            <div class="flex">
                <!-- Дата -->
                <vs-chip transparent color="primary">
                    {{ $moment(date).format("DD.MM.YYYY") }}
                </vs-chip>
                <!-- Статус заявки -->
                <vs-chip class="ml-2" color="danger">
                    {{ statusReq }}
                </vs-chip>
            </div>

            <div
                :class="wMobile ? 'flex-col' : ''"
                class="flex px-4 justify-between"
            >
                <!-- OLD -->

                <div class="mt-4">
                    <h3 class="mb-4">{{ $t("current_information") }}:</h3>
                    <div>
                        <img
                            style="max-width: 35vw"
                            :src="logo"
                            :onerror="`this.src='${require('@/assets/images/not-photo.png')}'`"
                        />
                    </div>

                    <div style="width: 90%" class="lg:flex justify-between mt-2">
                        <div>
                            <h4>
                                {{ titleOld }}
                            </h4>
                            <div class="flex mt-2 text-base">
                                <span class="font-bold"
                                    >{{ $t("type") }}:
                                </span>
                                <span class="ml-2">{{ typeOld }}</span>
                            </div>
                            <div class="flex text-base">
                                <span class="font-bold"
                                    >{{ $t("status") }}:</span
                                >
                                <span class="ml-2">{{
                                    statusOld ? $t("closed1") : $t("public")
                                }}</span>
                            </div>
                            <div class="flex text-base flex-wrap lg:flex-nowrap">
                                <span class="font-bold w-full lg:w-auto"
                                    >{{ $t("faculties") }}:</span
                                >
                                <span class="lg:ml-2">{{ facultyOld }}</span>
                            </div>
                            <div class="flex text-base flex-wrap lg:flex-nowrap">
                                <span class="font-bold"
                                    >{{ $t("director") }}:</span
                                >
                                <span class="lg:ml-2 w-full lg:w-auto"
                                    >{{ directorOld.lastName }}
                                    {{ directorOld.firstName }}
                                    {{ directorOld.middleName }}</span
                                >
                            </div>
                        </div>

                        <div
                            v-if="soclinksOld.length > 0"
                            class="mt-3 lg:mt-10 lg:ml-2 text-base"
                        >
                            <span class="font-bold"
                                >{{ $t("social_links") }}:</span
                            >
                            <div
                                v-for="link in soclinksOld"
                                :key="link.uid"
                                class="flex text-base"
                            >
                                <a
                                    class="font-bold"
                                    :href="link.social_link"
                                    target="_blank"
                                    >{{ link.social_web_type.name }}</a
                                >
                            </div>
                        </div>
                    </div>
                    <div class="flex-col mt-4">
                        <h5>{{ $t("description") }}:</h5>

                        <p class="mt-2 text-base">
                            {{ descriptionOld }}
                        </p>
                    </div>
                </div>
                <vs-divider v-if="wMobile"></vs-divider>
                <!-- NEW -->
                <div class="mt-4 ml-4">
                    <h3 class="mb-4">{{ $t("new_information") }}:</h3>
                    <div class="">
                        <img
                            style="max-width: 35vw"
                            :src="logo"
                            :onerror="`this.src='${require('@/assets/images/not-photo.png')}'`"
                        />
                    </div>

                    <div class="lg:flex justify-between mt-2" style="width: 90%">
                        <div>
                            <h4>
                                {{ title }}
                            </h4>
                            <div class="flex mt-2 text-base">
                                <span class="font-bold"
                                    >{{ $t("type") }}:
                                </span>
                                <span class="ml-2">{{ type }}</span>
                            </div>
                            <div class="flex text-base">
                                <span class="font-bold"
                                    >{{ $t("status") }}:</span
                                >
                                <span class="ml-2">{{
                                    status ? $t("closed1") : $t("public")
                                }}</span>
                            </div>
                            <div class="flex text-base flex-wrap lg:flex-nowrap">
                                <span class="font-bold"
                                    >{{ $t("faculties") }}:</span
                                >
                                <span class="lg:ml-2 w-full lg:w-auto">{{ faculty }}</span>
                            </div>
                            <div class="flex text-base flex-wrap lg:flex-nowrap">
                                <span class="font-bold"
                                    >{{ $t("director") }}:</span
                                >
                                <span class="lg:ml-2 w-full lg:w-auto"
                                    >{{ director.lastName }}
                                    {{ director.firstName }}
                                    {{ director.middleName }}</span
                                >
                            </div>
                        </div>

                        <div
                            v-if="soclinks.length > 0"
                            class="mt-3 lg:mt-10 lg:ml-2 text-base"
                        >
                            <span class="font-bold"
                                >{{ $t("social_links") }}:</span
                            >
                            <div
                                v-for="link in soclinks"
                                :key="link.uid"
                                class="flex text-base"
                            >
                                <a
                                    class="font-bold"
                                    :href="link.social_link"
                                    target="_blank"
                                    >{{ link.social_web_type.name }}</a
                                >
                            </div>
                        </div>
                    </div>

                    <div class="flex-col mt-4">
                        <h5>{{ $t("description") }}:</h5>

                        <p class="mt-2 text-base">
                            {{ description }}
                        </p>
                    </div>
                </div>
            </div>
            <div
                :class="wMobile ? 'flex-col' : ''"
                class="flex justify-end mt-8"
            >
                <vs-button
                    :class="wMobile ? 'mt-2' : ''"
                    color="warning"
                    class="ml-2"
                    @click="modification"
                    >{{ $t("revision") }}</vs-button
                >
                <vs-button
                    :class="wMobile ? 'mt-2' : ''"
                    color="danger"
                    class="ml-2"
                    type="border"
                    @click="cancel"
                    >{{ $t("reject") }}</vs-button
                >
                <vs-button
                    :class="wMobile ? 'mt-2' : ''"
                    class="ml-2"
                    @click="accept"
                    >{{ $t("accept") }}</vs-button
                >
            </div>
        </vs-card>
    </div>
</template>

<script>
import vsDivider from "../../../../localNodeModules/vuesax/components/vsDivider/vsDivider.vue";

export default {
    name: "EditCard",
    props: {
        date: [String],

        statusReq: [String],
        title: [String],
        type: [String],
        status: [String, Boolean],
        faculty: [String],
        description: [String],
        logo: [String],
        color: [String],

        director: {
            type: [Object],
            default: function () {
                return {};
            },
        },
        soclinks: [Array],

        statusReqOld: [String],
        titleOld: [String],
        typeOld: [String],
        statusOld: [String, Boolean],
        facultyOld: [String],
        descriptionOld: [String],
        logoOld: [String],

        directorOld: {
            type: [Object],
            default: function () {
                return {};
            },
        },
        soclinksOld: {
            type: [Array, Object],
        },
    },
    data() {
        return {};
    },
    computed: {
        wMobile() {
            return window.innerWidth < 800;
        },
    },
    methods: {
        accept() {
            this.$emit("accept");
        },
        cancel() {
            this.$emit("cancel");
        },
        modification() {
            this.$emit("modification");
        },
    },
};
</script>

<style>
</style>
